import { render, staticRenderFns } from "./DuplicationOverlay.vue?vue&type=template&id=e9ca3f10&scoped=true&"
import script from "./DuplicationOverlay.vue?vue&type=script&lang=js&"
export * from "./DuplicationOverlay.vue?vue&type=script&lang=js&"
import style0 from "./DuplicationOverlay.vue?vue&type=style&index=0&id=e9ca3f10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ca3f10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9ca3f10')) {
      api.createRecord('e9ca3f10', component.options)
    } else {
      api.reload('e9ca3f10', component.options)
    }
    module.hot.accept("./DuplicationOverlay.vue?vue&type=template&id=e9ca3f10&scoped=true&", function () {
      api.rerender('e9ca3f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/DuplicationOverlay.vue"
export default component.exports